import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from "react-toastify";
import { connect } from 'react-redux';
import { user, auth } from '../actions';
import { TOASTR_POSITION } from 'src/constants/configuration';
import { getAuthCookie } from 'src/utils/cookies';
import { withRouter } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import '../styles/custom-animation.css';
import '../styles/fonts.css';

import Header from './Header';
import Footer from './footer/Footer';
import Authorization from './Authorization';
import ModalWindows from './Modal';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;

class App extends Component {
  constructor() {
    super();
    this.refreshTokenEveryHour();
    this.intervalId = undefined;
  }

  componentDidMount() {
    const authCookie = getAuthCookie();
    if (authCookie) {
      this.props.refreshToken(authCookie);
      this.props.getUserProfile();
    }
  }

  componentWillUnmount() {
    if (this.intervalId !== undefined) {
      clearInterval(this.intervalId);
    }
  }

  refreshTokenEveryHour() {
    setInterval(() => {
      if (this.props.isAuthenticated) {
        this.props.refreshToken(getAuthCookie());
      }
    }, HOUR);
  }

  render() {
    const bodyColor = this.props.location.pathname === '/about' ? { background: '#111'} : { background: 'white' }
    return (
      <div className="App" style={bodyColor}>
        <ToastContainer position={TOASTR_POSITION}/>
        <ModalWindows />
        <Authorization />
        <Header />
        <div className="Body">
          {this.props.children}
        </div>
        <Footer/>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  getUserProfile: PropTypes.func.isRequired,
  refreshToken: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getUserProfile: user.getUserProfile,
    refreshToken: auth.refreshToken,
  })(App)
);





// WEBPACK FOOTER //
// ./src/components/App.js